import { Show } from "solid-js";
import { coinIcon } from "~/assets/assets";
import { Spacer } from "~/widgets/spacer";
import { toIndianNumber } from "~/utils/number";
import { useDenominationGridContext } from "../context/denomination_grid_context";

export function CoinConsumptionInformation() {
  const { externalProps, internalState } = useDenominationGridContext();
  return (
    <div class="flex w-full justify-between gap-2">
      <div class="flex items-center gap-1">
        <img src={coinIcon} class="h-[21px] w-[21px] pr-1" />
        <Show
          when={internalState.useRewardCoins()}
          fallback={
            <>
              <p class="text-mediumBold text-textDark lg:text-bold">
                Use rewards ·{" "}
              </p>
              <p class="text-mediumBold text-successDark lg:text-bold">
                Get ₹
                {externalProps.coinsBalance <= (internalState.dueAmount() ?? 0)
                  ? externalProps.coinsBalance
                  : internalState.dueAmount()}{" "}
                off
              </p>
            </>
          }
        >
          <p class="text-mediumBold text-successDark lg:text-bold">
            ₹{internalState.rewardDiscountAmount()} off
          </p>
          <p class="text-medium text-textNormal lg:text-normal">
            using {internalState.rewardDiscountAmount()} rewards
          </p>
        </Show>
      </div>
      <label class="inline-flex cursor-pointer items-center">
        <input
          type="checkbox"
          checked={internalState.useRewardCoins() ?? false}
          onChange={() => {
            internalState.setUseRewardCoins((prev) => !prev);
          }}
          class="peer sr-only"
        />
        <div
          class={`peer relative h-5 w-9 rounded-full border border-basePrimaryDark after:absolute after:start-[2px] after:top-[1px] after:h-4 after:w-4 after:rounded-full after:bg-basePrimaryDark after:transition-all after:content-[''] ${internalState.useRewardCoins() ? "peer-checked:bg-basePrimaryDark peer-checked:after:translate-x-full peer-checked:after:border-baseTertiaryLight peer-checked:after:bg-baseTertiaryLight peer-focus:outline-none rtl:peer-checked:after:-translate-x-full" : ""}`}
        ></div>
      </label>
    </div>
  );
}

export function CoinsOnlyConsumptionInfo() {
  const { internalState } = useDenominationGridContext();
  const {
    selectedAmount,
    isSimulating,
    dryRunErrorMessage: errorMessage,
  } = internalState;
  return (
    <div
      class="flex w-full flex-row items-center justify-center  text-[15px] font-semibold dark:text-textNormal"
      classList={{
        "opacity-40":
          isSimulating() || selectedAmount() == null || errorMessage() != null,
      }}
    >
      <span>Get using</span>
      <Spacer width={6} />
      <img src={coinIcon} class="h-[21px] w-[21px]" />
      <Spacer width={4} />
      <span class="text-[#E89901]">
        {toIndianNumber(internalState.dueAmount() ?? 0)}
      </span>
    </div>
  );
}
